export const addWeight = <K>(weights: Map<K, number>, key: K, weight: number) =>
  weights.set(key, (weights.get(key) ?? 0) + weight);

export const mostWeighted = <T, K>(items: T[], keyOf: (item: T) => K, weightOf: (item: T) => number = () => 1) => {
  const weights = new Map<K, number>();
  items.forEach((item) => addWeight(weights, keyOf(item), weightOf(item)));

  return [...weights.keys()].sort((a, b) => weights.get(b)! - weights.get(a)!);
};

export const dominantSizeOf = (runs: { sizePt: number; text: string }[]): number | undefined =>
  mostWeighted(
    runs,
    ({ sizePt }) => sizePt,
    ({ text }) => text.length,
  )[0];
